/* eslint-disable no-console */

type Log = unknown;

export class Console {
  static async info(log: Log): Promise<void> {
    console.log(log);
  }

  static async warning(log: Log): Promise<void> {
    console.warn(log);
  }

  static async error(log: Log): Promise<void> {
    console.error(log);
  }
}
